import languageRaws from '@/assets/hayawaza.tsv';
import store from '@/store';

export const hayawazaLangStorageKey = 'hayawazaLasng';

export class Language {
  private languages = {};
  private headers = [];

  public constructor() {
    this.readTsv();
  }

  /**
   * Read tsv local file
   */
  public async readTsv()
  {
    const raws = languageRaws.split('\n');
    raws.map((raw, rawIndex) => {
      const columns = raw.split('\t');

      if (rawIndex === 0) {
        this.headers = columns;
      }

      let index = 0;
      while (columns.length < this.headers.length) {
        columns[0] = columns[0].replace('\r', '');
        if (!columns[index]) {
          columns[index] = '';
        }
        index++;
      }

      let languageKey = '';
      if (columns[0]) {
        languageKey = columns[0];
      }

      columns.map((column, columnIndex) => {
        const language = this.headers[columnIndex];

        if (!this.languages[language]) {
          this.languages[language] = {};
        }

        if (language == 'English') {
          column = ' ' + column;
        }
        this.languages[language][languageKey] = column;
      })
    });
  }

  public getMessages() {
    return this.languages;
  }

  public setLang(lang) {
    localStorage.setItem(hayawazaLangStorageKey, lang);
    store.dispatch("LanguageStore/setLang", lang);
  }

  public getLang() {
    return localStorage.getItem(hayawazaLangStorageKey);
  }

  public getLangSuffixes() {
    let lang = '';
    switch (localStorage.getItem(hayawazaLangStorageKey)) {
    case '日本語': lang = 'ja'; break;
    case '한국어': lang = 'kr'; break;
    case '中文': lang = 'cn'; break;
    case 'English': lang = 'en'; break;

    default: lang = 'ja'; break;
    }
    return lang !== 'ja' ? `_${lang}` : '';
  }

  public getHeaders() {
    return this.headers;
  }

  public get appVersion() {
    return process.env.VUE_APP_VERSION || 'development'
  }
}

export default new Language();
